<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinics",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinics",
            items: [
               {
                  text: "Clinics",
                  active: true,
               },                   
            ],

            clinics: [],
            clinic_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            from: null,
            to: null,
            total: null,
            pagination: {},
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();
      },

      created() {
         this.fetchClinics();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");
         },
         fetchClinics(page_url = null) {

            this.getToken();
            let url = "api/admin/clinics?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.clinics = responseData.clinics.data;
                  
                  this.pagination = responseData.clinics.links;
                  this.from = responseData.clinics.from;
                  this.to = responseData.clinics.to;
                  this.total = responseData.clinics.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         activateClinic(clinic) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this clinic?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.clinic_status.id = clinic.id;
                  this.clinic_status.status = 1;
                  this.updateClinicStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateClinic(clinic) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this clinic?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.clinic_status.id = clinic.id;
                  this.clinic_status.status = 2;
                  this.updateClinicStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateClinicStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

     
            let url = "api/admin/clinics/status?clinic_id=" + this.clinic_status.id + "&status=" + this.clinic_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchClinics(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">                        
                        <router-link :to="{ name: 'clinics.add' }" class="btn btn-primary float-end">Add Clinic</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchClinics()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchClinics()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchClinics()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th>Name</th>  
                              <th>Place</th> 
                              <th>Latitude</th> 
                              <th>Longitude</th> 
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(clinics.length)">
                           <tr v-for="(clinic) in clinics" :key="clinic.id">
                              <td>{{clinic.name}}</td>
                              <td>{{clinic.place}}</td>
                              <td>{{clinic.latitude}}</td>
                              <td>{{clinic.longitude}}</td>
                              <td>{{clinic.created_at | formatDateTime }}</td>
                              <td>
                                 
                                 <router-link :to="{ name: 'clinics.details', params: {id: clinic.id} }" class="btn btn-primary btn-sm me-2 mb-2">Profile</router-link>
                                 <router-link :to="{ name: 'clinics.edit', params: {id: clinic.id} }" class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link>
                                 <router-link :to="{ name: 'clinics.doctors', params: {id: clinic.id} }" class="btn btn-primary btn-sm me-2 mb-2">Doctors</router-link>
                                 <router-link :to="{ name: 'clinics.tv', params: {id: clinic.id} }" class="btn btn-primary btn-sm me-2 mb-2">TV</router-link>
                                 <router-link :to="{ name: 'clinics.tv.networkusages', params: {id: clinic.id} }" class="btn btn-primary btn-sm me-2 mb-2">Tv Network Usages</router-link>
                                 <router-link :to="{ name: 'clinics.bookings' , params: {id: clinic.id}}" class="btn btn-primary btn-sm me-2 mb-2">Bookings</router-link>
                                 <router-link :to="{ name: 'clinics.settings' , params: {id: clinic.id}}" class="btn btn-primary btn-sm me-2 mb-2">Settings</router-link>


                                 <b-button v-if="clinic.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateClinic(clinic)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateClinic(clinic)">Publish</b-button>
                              </td>
                           </tr>
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No clinics found</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(clinics.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchClinics(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->              

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
